export default __webpack_public_path__ + "static/media/subhero1.ec771095.jpeg";